
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ref-card',
  props: {
    type: String,
    source: String,
    year: String,
    content: String,
    url: String,
  },
  methods: {
    isMobile() {
      let resp = false;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        resp = true;
      }
      return resp;
    },
  },
});
